module.exports = {
  INITIATED: 'INITIATED',
  CREATED: 'CREATED',
  ENQUEUED: 'ENQUEUED',
  PROCESSING: 'PROCESSING',
  CONFIRMED: 'CONFIRMED',
  PAID: 'PAID',
  ERROR: 'ERROR'
};
